import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { CookieService } from 'ngx-cookie-service';
import { IvyCarouselModule } from 'angular-responsive-carousel';

import { LOCALE_ID} from '@angular/core';
import {registerLocaleData} from '@angular/common';
import localeRu from '@angular/common/locales/ru';

// Modules
import { FooterModule } from './common/footer/footer.module';
import { WidgetsModule } from './common/widgets/widgets.module';
import { MatDialogModule } from '@angular/material/dialog';

import { FormElementsModule } from './common/form/formElements.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainComponent } from './pages/main/main.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { HeaderComponent } from './common/header/header.component';
import * as Dialogs from './common/dialog';
import {YandexAdModule} from './common/yandex-ad/yandex-ad.module';
// import {TimerModule} from "./common/timer/timer.module";

registerLocaleData(localeRu, 'ru');

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    NotFoundComponent,
    HeaderComponent,
    Dialogs.DialogDeleteComponent,
    Dialogs.DialogInfoComponent,
    Dialogs.DialogGalleryComponent,
    Dialogs.DialogNewImageComponent
  ],
  imports: [
    YandexAdModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FooterModule,
    WidgetsModule,
    LeafletModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    FormElementsModule,
    IvyCarouselModule
    // TimerModule
  ],
  providers: [CookieService, { provide: LOCALE_ID, useValue: 'ru' }],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    // NO_ERRORS_SCHEMA
  ],
  entryComponents: [
    Dialogs.DialogDeleteComponent,
    Dialogs.DialogInfoComponent,
    Dialogs.DialogGalleryComponent,
    Dialogs.DialogNewImageComponent
  ]
})
export class AppModule {}
